import {
  AccessTokenResponseDto,
  ImpersonatorApiImpersonatorControllerGetAccountsRequest,
  ImpersonatorApiImpersonatorControllerImpersonateRequest,
} from '@givz/core-client';
import { useState } from 'react';
import {
  useCoreClientMutation,
  UseCoreClientMutationParams,
  useCoreClientQuery,
} from './client';

export const impersonatorKeys = {
  base: ['impersonator'] as const,
  listAccounts: (
    params: ImpersonatorApiImpersonatorControllerGetAccountsRequest,
  ) => [...impersonatorKeys.base, 'listAccounts', params] as const,
};

export const useImpersonate = (
  params?: Partial<
    UseCoreClientMutationParams<
      AccessTokenResponseDto,
      unknown,
      ImpersonatorApiImpersonatorControllerImpersonateRequest
    >
  >,
) => {
  return useCoreClientMutation({
    ...params,
    mutationFn: (client) => client.Impersonator.impersonateHosted,
  });
};

export const useImpersonatorListAccounts = (
  args: Pick<ImpersonatorApiImpersonatorControllerGetAccountsRequest, 'q'> = {},
) => {
  const [searchParams, setSearchParams] =
    useState<ImpersonatorApiImpersonatorControllerGetAccountsRequest>(args);

  return [
    useCoreClientQuery({
      queryFn: (client) => (_queryContext) =>
        client.Impersonator.listHostedAccounts(searchParams),
      queryKey: impersonatorKeys.listAccounts(searchParams),
      staleTime: Infinity,
    }),
    setSearchParams,
  ] as const;
};
